import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'index',
    redirect: '/home',
    component: () => import('../views/index.vue'),
    children: [
      {
        path: '/home',
        component: () => import('../views/home.vue'),
        meta: {
          title: '专专发|专线直发-专线直达'
        }
      },
      {
        path: '/delivery',
        component: () => import('../views/delivery.vue'),
        meta: {
          title: '专专发|在线发货平台'
        }
      },
      {
        path: '/record',
        component: () => import('../views/record.vue'),
        meta: {
          title: '专专发|物流发货记录查询'
        }
      },
      {
        path: '/addressbook',
        component: () => import('../views/addressbook.vue'),
        meta: {
          title: '专专发|常用物流地址管理'
        }
      },
      {
        path: '/template',
        component: () => import('../views/template.vue'),
        meta: {
          title: '专专发|货物信息模板'
        }
      },
      {
        path: '/manager',
        component: () => import('../views/manager.vue'),
        meta: {
          title: '专专发|专属物流顾问'
        }
      },
      {
        path: '/truckload',
        component: () => import('../views/truckload.vue'),
        meta: {
          title: '专专发|零担发货专线运输'
        }
      },
      {
        path: '/large',
        component: () => import('../views/large.vue'),
        meta: {
          title: '专专发|大件整车发货专线'
        }
      },
      {
        path: '/assist',
        component: () => import('../views/assist.vue'),
        meta: {
          title: '专专发|专线物流常见问题'
        }
      }
    ],
  },
]

// 防止连续点击多次路由报错
let routerPush = Router.prototype.push
let routerReplace = Router.prototype.replace
// push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch((err) => err)
}
// replace
Router.prototype.replace = function push(location) {
  return routerReplace.call(this, location).catch((err) => err)
}

const router = new Router({
  mode: 'hash',
  scrollBehavior: () => ({ y: 0 }),
  routes,
})

// 添加全局前置守卫设置页面标题
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  } else {
    // 默认标题
    document.title = '专专发|专线直发-专线直达'
  }
  next()
})

// 添加全局后置守卫
router.afterEach((to, from) => {
  // 在路由切换完成后滚动到顶部
  window.scrollTo(0, 0)
  console.log(123)
})

export default router